<div class="header">
  <img
    class="header-logo"
    src="../../../assets/header-logo.svg"
    routerLink="/printer"
    alt="header-logo"
  />
  <span>{{ (isPrinter() ? 'printerHeader' : 'sendToEtrieve') | translate }}</span>
</div>
